module.exports = __webpack_public_path__ + "static/media/minus.3f87c43a.svg";